import React, { useEffect, useState, useMemo } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { Grid2, Box, CircularProgress, Typography } from "@mui/material";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const PdfViewer = ({
  pdfFile,
  bucketName = "tipkit-website-docs",
  scaleBase = 900,
}) => {
  const [numPages, setNumPages] = useState(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const pdfUrl = useMemo(() => {
    if (!pdfFile) return null;

    // if full URL
    if (pdfFile.startsWith("http")) return pdfFile;

    // if only path passed
    return `https://storage.googleapis.com/${bucketName}/${pdfFile}`;
  }, [pdfFile, bucketName]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setLoading(false);
    setError("");
  };

  const onDocumentLoadError = () => {
    setLoading(false);
    setError("Please try again later.");
  };

  const scale = windowWidth / scaleBase;

  return (
    <Box
      sx={{
        backgroundColor: "#f8f9fa",
        py: 5,
        minHeight: "100vh",
      }}
    >
      <Grid2 container justifyContent="center">
        <Grid2 item>
          {loading && (
            <Box textAlign="center" py={5}>
              <CircularProgress />
              <Typography mt={2}>Loading PDF...</Typography>
            </Box>
          )}

          {error && (
            <Typography color="error" textAlign="center">
              {error}
            </Typography>
          )}

          {pdfUrl && (
            <Document
              file={pdfUrl}
              onLoadSuccess={onDocumentLoadSuccess}
              onLoadError={onDocumentLoadError}
              loading=""
            >
              {Array.from(new Array(numPages), (_, index) => (
                <Page
                  key={`page_${index + 1}`}
                  pageNumber={index + 1}
                  renderTextLayer={false}
                  renderAnnotationLayer={false}
                  width={Math.min(windowWidth - 40, 900)}
                />
              ))}
            </Document>
          )}
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default PdfViewer;
